import { setup } from 'additiv-services';

setup({
    withBearerApplicationAccessToken: true,
    GATEWAY_API_URL: globalThis.AppConfig.GATEWAY_API_URL,
    SERVICES_URL_SUFFIX: globalThis.AppConfig.SERVICES_URL_SUFFIX,
    DMS_URL_SUFFIX: globalThis.AppConfig.DMS_URL_SUFFIX,
    GRAPHQL_URL_SUFFIX: globalThis.AppConfig.GRAPHQL_URL_SUFFIX,
    CUSTOM_URL_SUFFIX: globalThis.AppConfig.CUSTOM_URL_SUFFIX,
    ENGAGEMENT_CONTENT_URL_SUFFIX: globalThis?.AppConfig?.ENGAGEMENT_CONTENT_URL_SUFFIX,
    FIDENTITY_URL_SUFFIX: globalThis?.AppConfig?.FIDENTITY_URL_SUFFIX,
    CLIENT_SERVICE_MEMBER_URL_SUFFIX: globalThis.AppConfig.CLIENT_MEMBER_URL_SUFFIX,
    CLIENT_SERVICE_URL_SUFFIX: globalThis.AppConfig.CLIENT_SERVICE_URL_SUFFIX,
    CSL_URL_SUFFIX: globalThis.AppConfig.CSL_URL_SUFFIX,
    WMS_SERVICE_URL_SUFFIX: globalThis.AppConfig.WMS_SERVICE_URL_SUFFIX,
    IFRAME_CASE_MANAGEMENT_URL: globalThis.AppConfig.IFRAME_CASE_MANAGEMENT_URL,
    BO_ADDITIV_URL: globalThis.AppConfig.BO_ADDITIV_URL,
    BO_ZIAG_URL: globalThis.AppConfig.BO_ZIAG_URL,
    CREDIT_APP_URL: globalThis.AppConfig.CREDIT_APP_URL ?? false,
    CREDIT_APP_ZIAG_URL: globalThis.AppConfig.CREDIT_APP_ZIAG_URL ?? false,
    SYSTEM_MESSAGE_FEATURE_FLAG: globalThis.AppConfig.SYSTEM_MESSAGE_FEATURE_FLAG ?? false,
    CREDIT_INTEGRATION_FEATURE_FLAG: globalThis.AppConfig.CREDIT_INTEGRATION_FEATURE_FLAG ?? false,
    UPLOAD_STATIC_DOCUMENT_FEATURE_FLAG: globalThis.AppConfig.UPLOAD_STATIC_DOCUMENT_FEATURE_FLAG ?? false,
    PRODUCT_PROPOSAL_FEATURE_FLAG: globalThis.AppConfig.PRODUCT_PROPOSAL_FEATURE_FLAG ?? false,
    CREDITSERVICELAYER_SERVICE_URL_SUFFIX: globalThis.AppConfig.CREDITSERVICELAYER_SERVICE_URL_SUFFIX,
});
